import { Component, OnInit, Input, AfterViewInit, ViewEncapsulation, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { ClassificationsListModel } from './classifications-list.model';
import { GetClassificationsListService } from './api-services/get-classifications-list.service';

/**
 * 部門情報リストクラス
 *
 * @export
 * @class ClassificationsListComponent
 * @implements {OnInit}
 * @implements {AfterViewInit}
 */
@Component({
  selector: 'app-classifications-list',
  templateUrl: './classifications-list.component.html',
  styleUrls: ['./classifications-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ClassificationsListComponent implements OnInit, AfterViewInit, OnChanges {

  /* FlexのUI再現のため 最後にクリックされたIDを取得 */
  public lastClickId: string = <string>'';

  /* モデルインスタンス化 */
  public classificationsListModel = new ClassificationsListModel();

  @ViewChild('list', { static: true }) public list: ElementRef;

  @Input() public subid: string = null;
  /* 位置調整用のパラメーター */
  @Input() left: number = <number>0;
  @Input() top: number = <number>0;
  @Input() width: number | string;
  @Input() height: number = <number>30;
  @Input() tabindex: number = <number>-1;

  /* そのほかパラメーター */
  @Input() invalidCode: string = <string>'';                                    // 画面に表示させないコード
  @Input() initFocusItem: any = null;
  @Input() forcedEnabledMode: string = null;

  private _initFocusItem: any = null;

  // 選択アイテム
  public selectedItems: any;

  /**
   * コンストラクタ
   *
   * @param {GetClassificationsListService} getClassificationsListService
   * @memberof ClassificationsListComponent
   */
  constructor(
    private getClassificationsListService: GetClassificationsListService,
    public elementRef: ElementRef,
    ) { }

  /**
   * 初期処理
   *
   * @memberof ClassificationsListComponent
   */
  ngOnInit(): void {
    // 自身をモデルに入れる
    this.classificationsListModel.classificationsList = this;
    this.list.nativeElement.setAttribute('id', this.subid + '_sub');
    this.list.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * ロード完了時
   *
   * @memberof ClassificationsListComponent
   */
  ngAfterViewInit(): void {
    // データ取得
    this.getClassificationsListService.execute(this.classificationsListModel);
  }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof ClassificationsListComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'initFocusItem':
          // 先頭空白表示フラグ
          this._initFocusItem = changes.initFocusItem.currentValue;
          break;
      }
    });
  }

  /**
   * コード更新完了 渡されたID属性へ遷移する
   *
   * @memberof ClassificationsListComponent
   */
  public updateListComplete(): void {
    if (this._initFocusItem != null) {
      if (this.initFocusItem instanceof HTMLElement) {
        this.initFocusItem.focus();
      } else {
        // 参照先の型がElementでない(Component)ならComponent内の要素を見て最初のinput,textarea,selectElementにフォーカスをあてる
        for (const child of this.initFocusItem.elementRef.nativeElement.children) {
          if (child instanceof HTMLInputElement || child instanceof HTMLTextAreaElement || child instanceof HTMLSelectElement) {
            child.focus();
            break;
          }
        }
      }
      this._initFocusItem = null;
    }
  }

}
